import { userService } from '@/services/userService.js';
import postQueue from '@/services/postQueue';
import attendSaveQueue from '@/services/attendSaveQueue';
export const user = {
  namespaced: true,
  state: {
    loggedinUser: null,
    isDrawerOpen: false,
    isLoading: false,
    isOnline: navigator.onLine !== undefined ? navigator.onLine : true,
    alertData: null,
  },
  getters: {
    users(state) {
      return state.users;
    },
    loggedinUser(state) {
      return state.loggedinUser;
    },
    isDrawerOpen(state) {
      return state.isDrawerOpen;
    },
    isLoading(state) {
      return state.isLoading;
    },
    isOnline(state) {
      return state.isOnline;
    },
    alertData(state) {
      return state.alertData;
    },
  },
  mutations: {
    setUser(state, user) {
      state.loggedinUser = user;
    },
    setUsers(state, { users }) {
      state.users = users;
    },
    removeUser(state, { userId }) {
      state.users = state.users.filter((user) => user._id !== userId);
    },
    toggleDrawer(state, val) {
      state.isDrawerOpen = val;
    },
    setAlertData(state, { alertData }) {
      state.alertData = alertData;
    },
    toggleLoader(state, val) {
      if (val !== undefined && val !== null) state.isLoading = val;
      else state.isLoading = !state.isLoading;
    },
    setIsOnline(state, val) {
      if (!state.isOnline && val) {
        postQueue.playQueue();
        attendSaveQueue.playQueue();
      }
      state.isOnline = val;
    },
  },
  actions: {
    async loadUsers(context) {
      const users = await userService.query();
      context.commit({ type: 'setUsers', users });
    },
    async removeUser(context, { userId }) {
      await userService.remove(userId);
      context.commit({ type: 'removeUser', userId });
    },
    async updateUser(context, { user }) {
      user = await userService.update(user);
      context.commit({ type: 'setUser', user });
    },
  },
};
